import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import TestimonialForm from "../components/TestimonialForm";
import CoverLetterModal from "../pages/CoverLetterModal"; // ✅ Importing modal
import "../styles/SuccessPage.css";

const SuccessPage = ({ user }) => {
  const navigate = useNavigate();
  const testimonials = useSelector((state) => state.form.testimonials);

  const [showModal, setShowModal] = useState(false);

  // ✅ Listen to event triggered from Navbar to open modal
  useEffect(() => {
    const handleOpen = () => setShowModal(true);
    window.addEventListener("openCoverLetterModal", handleOpen);

    return () => {
      window.removeEventListener("openCoverLetterModal", handleOpen);
    };
  }, []);

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #1e3c72, #2a5298)",
        minHeight: "100vh",
        padding: "3rem 1rem",
        color: "#fff",
      }}
    >
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-5"
        >
          <h1
            className="fw-bold mb-3"
            style={{ color: "#81d4fa", fontSize: "2.5rem" }}
          >
            🎉 Application Submitted!
          </h1>
          <p className="lead text-light">
            Thank you for applying! Your application has been received
            successfully. ✨
          </p>
          <p style={{ color: "#cfd8dc", fontSize: "15px" }}>
            We’ll notify you via email once your application is reviewed.
          </p>
          <div className="mt-4">
            <button
              className="btn"
              style={{
                background: "linear-gradient(45deg, #00bcd4, #1e88e5)",
                color: "#fff",
                fontWeight: "600",
                borderRadius: "6px",
                padding: "8px 16px",
                fontSize: "14px",
                width: "100%",
                maxWidth: "220px",
              }}
              onClick={() => navigate("/form")}
            >
              Submit Again
            </button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="testimonial-section px-3"
        >
          {/* <h3 className="text-center mb-4" style={{ color: "#fff" }}>
            ❤️ What Our Applicants Say
          </h3> */}

          <div className="row justify-content-center">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.id || index}
                className="col-md-4 mb-4"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2 }}
              >
                <div
                  className="card border-0 shadow-sm p-3"
                  style={{
                    borderRadius: "15px",
                    background: "#ffffff10",
                    border: "1px solid #ffffff30",
                    backdropFilter: "blur(6px)",
                    color: "#fff",
                  }}
                >
                  <div className="card-body text-center">
                    <img
                      src={
                        testimonial.photo || "https://via.placeholder.com/80"
                      }
                      alt={testimonial.name}
                      className="rounded-circle mb-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        border: "3px solid #81d4fa",
                      }}
                    />
                    <h5 className="fw-semibold mb-1 text-info">
                      {testimonial.name}
                    </h5>
                    <p className="text-light" style={{ fontSize: "14px" }}>
                      {testimonial.role || "User"}
                    </p>
                    <p
                      className="card-text"
                      style={{
                        fontStyle: "italic",
                        fontSize: "15px",
                        color: "#cfd8dc",
                      }}
                    >
                      “{testimonial.message}”
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {user && <TestimonialForm user={user} />}
      </div>

      {/* ✅ Show modal when triggered */}
      {showModal && <CoverLetterModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default SuccessPage;
